import React from 'react'
import {
  Pagination,
  message,
  Input,
  Button,
  Table,
  Select,
  Modal,
} from 'antd'
import styles from './commodity-qualification.module.less'
import common from '@/public/common'
import { ajaxApi } from '@/server/index'
import 'moment/locale/zh-cn'
import { getCookie, getParmUrl } from '@/public/utils'
const { Option } = Select
const { TextArea } = Input
class ManufacturerComponent extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      visible: true,
      paramData: {
        qua_category: '',
        name: '',
        page_index: 1,
        page_size: 10
      },
      tableData: [],
      testUrl: window.location.host.split('t').length - 1 === 1,
      total: 0,
      updateitemsupplierParam: {
        'qua_item_id': null,
        'editer': getCookie('otheradminName') ? JSON.parse(getCookie('otheradminName')).UserID : '',
        // editer: getCookie("AdminID"),
        'qua_category': '',
        'vender_id': null
      },
      tabKey: '0'
    }
  }

  componentDidMount () {
    let {updateitemsupplierParam} = this.state
    updateitemsupplierParam.qua_item_id = this.props.postData.qua_item_id
    updateitemsupplierParam.qua_category = this.props.chooseFirmParam.qua_category
    this.setState(
      {
        paramData: this.props.chooseFirmParam,
        updateitemsupplierParam,
        Category: this.props.quaCategory,
        tabKey: this.props.tabActiveKey
      },
      () => {
        this.getManufacturerData()
      }
    )
  }

  //
  componentWillReceiveProps (nextprops) {
    let {updateitemsupplierParam} = this.state
    updateitemsupplierParam.qua_item_id = nextprops.postData.qua_item_id
    updateitemsupplierParam.qua_category = nextprops.chooseFirmParam.qua_category
    this.setState({
      paramData: nextprops.chooseFirmParam,
      Category: nextprops.quaCategory,
      tabKey: nextprops.tabActiveKey
    })
  }

  // 获取历史资质的数据
  getManufacturerData = async () => {
    let { paramData, testUrl, qualificationData } = this.state
    try {
      let res = await ajaxApi({
        url: common.scpUrl + 'item/query-supplier-category',
        params: paramData
      })
      if (res.status === 200) {
        if (res.data.data.length !== 0) {
          let _data = res.data.data
          _data.map((item, index) => {
            item.key = index
          })
          this.setState({
            tableData: _data,
            total: res.data.totalnum
          })
        } else {
          this.setState({
            tableData: [],
            total: 0
          })
        }
      }
    } catch (e) {
      console.log(e)
    }
  };

  // 查询
  handleSearch=() => {
    let {paramData} = this.state
    paramData.page_index = 1
    this.setState({
      paramData
    }, () => {
      this.getManufacturerData()
    })
  }

  // 分页
  pageChage = (page, pagesize) => {
    let { paramData } = this.state
    paramData.page_index = page - 1
    this.setState(
      {
        paramData
      },
      () => {
        this.getManufacturerData()
      }
    )
  };

  // 页数据修改
  onShowSizeChange = (current, pageSize) => {
    try {
      let { paramData } = this.state
      paramData.page_size = pageSize
      paramData.page_index = current
      this.setState(
        {
          paramData
        },
        () => {
          this.getManufacturerData()
        }
      )
    } catch (error) {
      console.log(error)
    }
  };

  // 选择
  handleChoose=async (e, record) => {
    let {updateitemsupplierParam, Category} = this.state
    updateitemsupplierParam.vender_id = record.vender_id
    if (Category === 'Agent') {
      this.props.getAgentRecord(record)
      this.props.chooseManufacturerVisible(false)
    } else {
      try {
        let res = await ajaxApi({
          url: common.scpUrl + 'item/update-item-supplier',
          params: updateitemsupplierParam
        })
        if (res.status === 200) {
          message.success('修改成功', 1.5)
          // this.props.chooseManufacturerVisible(false)
          window.location.reload()
          this.props.manufacturersServiceProviders(this.state.tabKey)
        }
      } catch (e) {
        console.log(e)
      }
    }
  }

  // 获取输入框的值
  handleChangeInput=(e) => {
    let {paramData} = this.state
    paramData.name = e.target.value
    this.setState({
      paramData
    })
  }

  // 取消
  handleCancel = () => {
    this.props.chooseManufacturerVisible(false)
  };

  render () {
    let { tableData } = this.state
    const columns = [
      {
        title: '名称',
        dataIndex: 'vender_name',
        key: 'vender_name',
        render: (text, record) => (
          <span>{record.vender_name ? record.vender_name : '-'}</span>
        )
      },
      {
        title: '类别',
        dataIndex: 'is_producer',
        key: 'is_producer',
        render: (text, record) => (
          <span>
            <span style={{ marginRight: '8px' }}>
              {record.is_producer ? '生产企业（含受托）' : ''}
            </span>
            <span style={{ marginRight: '8px' }}>
              {record.is_service ? '服务商' : ''}
            </span>
            <span style={{ marginRight: '8px' }}>
              {record.is_supplier ? '代销商' : ''}
            </span>
            <span style={{ marginRight: '8px' }}>
              {record.is_agent ? '代理商' : ''}
            </span>
            <span style={{ marginRight: '8px' }}>
              {record.is_register ? '注册人/备案人' : ''}
            </span>
          </span>
        )
      },
      {
        title: '操作',
        dataIndex: 'optation',
        key: 'optation',
        width: 100,
        render: (text, record) => (
          <span>
            <a
              onClick={(e) => this.handleChoose(e, record)}
              style={{ color: 'coral' }}
            >
              选择
            </a>
          </span>
        )
      }
    ]
    return (
      <div>
        <Modal
          title={this.state.modalTitle}
          visible={this.state.visible}
          onOk={this.handleOk}
          width={900}

          onCancel={this.handleCancel}
          footer={false}
        >
          <div style={{marginBottom: '24px'}}>
            <span>名称：</span>
            <Input
              placeholder="请输入"
              value={this.state.paramData.name}
              onChange={this.handleChangeInput}
              style={{
                width: 272,
                marginRight: '8px'
              }}
            />
            <span>
              {' '}
              <Button
                type="primary"
                style={{ marginLeft: '16px' }}
                onKeyDown={this.onKeyup}
                onClick={this.handleSearch}
              >
                查询
              </Button>
            </span>
          </div>

          <div>
            <Table
              columns={columns}
              pagination={false}
              // scroll={{ y: 450 }}
              rowKey={(record) => record.key}
              // rowSelection={rowSelection}
              scroll= {{y: 300}}
              loading={this.state.detalLoading}
              onChange={this.handleSort}
              dataSource={this.state.tableData}
            ></Table>
          </div>

          <div className={styles.page}>
            <span
              style={{
                position: 'absolute',
                left: '2px',
                top: '-4px',
                fontSize: '14px'
              }}
            >
              <span>共</span>
              <span>{this.state.total}</span>
              <span>条记录</span>
            </span>
            <Pagination
              current={this.state.paramData.page_index}
              showQuickJumper
              total={this.state.total}
              showSizeChanger
              onShowSizeChange={this.onShowSizeChange}
              onChange={this.pageChage}
            />
          </div>

          <div
            style={{ textAlign: 'center', marginTop: '24px', display: 'none' }}
          >
            <Button
              type="primary"
              style={{ marginLeft: '16px' }}
              onKeyDown={this.onKeyup}
              //   loading={btnLoadings.okLoading}
              onClick={(e) => this.handleOk(e)}
            >
              确定
            </Button>
            <Button
              type="primary"
              style={{ marginLeft: '16px' }}
              onKeyDown={this.onKeyup}
              onClick={this.handleCancel}
            >
              取消
            </Button>
          </div>
        </Modal>
      </div>
    )
  }
}
export default ManufacturerComponent



// WEBPACK FOOTER //
// ./src/pages/commoditymanagement/commodityqualification/manufacturercomponent.js